import { render, staticRenderFns } from "./AppointmentTypeForm.vue?vue&type=template&id=65d05fd0"
import script from "./AppointmentTypeForm.vue?vue&type=script&lang=js"
export * from "./AppointmentTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports